import { createSlice } from '@reduxjs/toolkit';

export const langSlice = createSlice({
  name: 'lang',
  initialState: {
    lang: 'fr'
  },
  reducers: {
    setLang: (state, action) => {
      state.lang = action.payload;
    },
  }
});

export const {setLang} = langSlice.actions;

export const langSelector = state => state.lang.lang;

export default langSlice.reducer;